<template>
  <div>
    <el-dialog :title="$i18.language('创建商机列表')" class="smart-dialog" :close-on-click-modal="false" :append-to-body="false" :visible.sync="dialogVisible">
      <el-form class="smart-form" ref="smartform" :model="params" :rules="rules">
        <el-form-item prop="title">
          <p class="label">  {{ $t('tableHeader.listName') }}： </p>
          <div>
            <el-input :maxlength="100" clearable v-model="params.title"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="searchType">
          <p class="label">{{$i18.language('将当前查询结果中的采/供应商保存入列表中')}}：</p>
          <div class="">
            <el-select popper-class="customer-select" class="smart-business-select" v-model="params.searchType" placeholder="">
              <el-option v-for="item in searchTypes" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item prop="sortType">
          <p class="label">{{$i18.language('为智能列表新增排序方式')}}：</p>
          <div class="">
            <el-select popper-class="customer-select" class="smart-business-select" v-model="params.sortType" placeholder="">
              <el-option v-for="item in sortTypes" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item prop="sortType">
          <p class="label">
            <span>{{$i18.language('自动加入符合查询条件企业')}}：</span>
            <el-switch v-model="params.autoJoin"></el-switch>
          </p>
        </el-form-item>
      </el-form>
      <div class="smart-business-tips">
        <p>{{$i18.language('注意：')}}</p>
        <p>{{$i18.language('1、商机列表中，新增的排序方式需要在创建之后的24小时之后生效。')}}</p>
        <p>{{$i18.language('2、开启自动加入查询条件企业时，系统还将单独列出当前自然月中新增企业。')}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" class="sub-confirm-btn" @click="cancel">{{ $t('cancel') }}</el-button>
        <el-button size="mini" class="confirm-btn" @click="confirm">{{ $t('sure') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SmartBusisnessDialog',

  data() {
    return {
      rules: {
        title: [{required: true, message: this.$t('message.prompt.cannotEmpty')}]
      },
      dialogVisible: false,
      params: {
        title: "",
        searchType: 1, //1 采购商 2供应商
        sortType: 1,//排序方式 1,2,3,4
        autoJoin: false, //是否自动添加
      },
      defaultData: {countryIds: [0],
        autoTranslate: true,
        fullAddressMatchs: [], //完整地址模糊匹配
        productDescriptions:[],
        hsCodes: [],
        industryCategorys:[], //行业分类
        industryType: '',
        companyNames: [], //公司名称
        companyNumbers: [], //企业税号
        companyWebsites: [], //公司网址
        buyerCompanys: [], //采购商名称
        supplierCompanys: [], //供应商名称
        tradeDate: 0, //近几年有交易记录
        tradeCount: -1, //限制交易次数
        buyFromArea: 0,
        dataSourceCountryId: 43, //采购商来源国/供应市场国
        excludeLogistics: false,
        excludeBank: false,
        showContactIcon: false,
        containContact: '',},
      // 采购商/供应商
      searchTypes: [
        {label: this.$t('purchaser'), value: 1},
        {label: this.$t('supplier'), value: 2},
      ],
      // 排序方式
      sortTypes: [
        {label: this.$i18.language('查询条件相关的交易单数排序'), value: 1},
        {label: this.$i18.language('查询条件相关的交易金额排序'), value: 2},
        {label: this.$i18.language('查询条件相关的交易重量排序'), value: 3},
        {label: this.$i18.language('查询条件相关的交易箱量排序'), value: 4},
      ],
    };
  },

  mounted() {
    
  },

  methods: {
    open(data) {
      data = Object.assign(this.defaultData, data)
      let params = JSON.parse(JSON.stringify(data))
      delete params.pageIndex
      delete params.pageSize
      this.$set(this.params, 'searchData', params);
      let nonEmptyKeys = this.handleEmptyParams()
      if(!nonEmptyKeys.length) {
        this.$message.warning(this.$i18.language('商机列表必须包含产品描述、HS编码、公司名称中任意1个条件。'))
        return
      }
      let {type} = data
      this.params.searchType = [1,2].includes(type)?type:1
      this.dialogVisible = true
    },
    // 判断是否空结果
    handleEmptyParams() {
      let {productDescriptions, hsCodes, companyNames, buyerCompanys, supplierCompanys} = this.params.searchData
      let obj = {productDescriptions, hsCodes, companyNames, buyerCompanys, supplierCompanys}
      let nonEmptyKeys = Object.entries(obj)
      .filter(([key, value]) => {
        if (Array.isArray(value)) {
          return value.length > 0 && Object.values(value).filter(item=>typeof(item)==='object'?item.value:item).length; // 如果值是数组，只有当数组非空时才视为非空属性
        } else {
          return value !== null && value !== undefined && value !== ''; // 对于非数组值，只有当值不为null、undefined和空字符串时才视为非空属性
        }
      }).map(([key, value]) => key);
      return nonEmptyKeys
    },
    cancel() {
      this.dialogVisible = false
      this.$emit('closeBusisness');
    },
    // 确认
    confirm() {
      this.$refs['smartform'].validate(async valid => {
        if(valid) {
          let res = await this.$api.company.saveSmartBusiness(this.params)
          if(res.code == 200) {
            this.$message.success(this.$t('message.success.addSuccessLook'))
            this.cancel()
          }
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.smart-business-select {
  width: 100%;
}
.smart-dialog {
  /deep/.el-dialog__body {
    min-height: 60vh;
    position: relative;
  }
}
.smart-form {
  .label {
    color: $--font-color-text-6;
    margin-bottom: 7px;
    line-height: 1em;
  }
}
.smart-business-tips {
  color: $--color-theme;
  position: absolute;
  bottom: 24px;
  line-height: 16px;
  p {
    margin-top: 10px;
  }
}
</style>